import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import React, { useEffect, useState } from "react";
import GlobalMeta from "../../reusable/GlobalMeta";
import { useParams } from "react-router-dom";
import InternalBanner from "../../reusable/fieldGroups/InternalBanner";
import { Grid, Skeleton, Typography } from "@mui/material";
import { Box, Container } from "@mui/system";
import HTMLComponents from "../../reusable/htmlToReact";
import ImageBGSection from "../../reusable/fieldGroups/ImageBGSection";
import ExperienceCard from "./ExperienceCard";
import { useMediaQuery } from '@mui/material';

export default function SingleExperience(){

    const {'*':slug}=useParams();

    const smDown = useMediaQuery(theme => theme.breakpoints.down('sm'));

    const [pageData, setPageData]=useState();
    const [notFound, setNotFound]=useState(false);
    const [partner, setPartner]=useState();
    const [filter, setFilter]=useState([]);

    //Fetch page
    const { isPending, isError, data, error, isInitialLoading }=useQuery(
        ['page', slug], //Query key and dependency
        ()=>axios({ //Query function
            method:'get',
            url:WP_API_Settings.endpoint+'wp/v2/theme_experience?slug='+slug+'&_embed=true&acf_format=standard'
        })
    );

    useEffect(()=>{
        if(data?.data){
            if(data.data.length){
                setPageData(data.data[0]);
                setNotFound(false);
                axios({
                    method: 'get',
                    url: WP_API_Settings.endpoint+'wp/v2/partners/'+data.data[0].partners[0]+'?_embed=true&acf_format=standard'
                })
                .then(response => {
                    setPartner(response.data);
                })
                axios({
                    // Fetch related experiences, excluding the current page
                    method: 'get',
                    url: WP_API_Settings.endpoint + 'wp/v2/theme_experience',
                    params: {
                        [data.data[0].filter[0]]: data.data[0].id,
                        _embed: true,
                        acf_format: 'standard',
                        per_page: 2,
                        page: 1,
                        orderby: 'date',
                        order: 'asc',
                        exclude: data.data[0].id,
                        filter: data.data[0].filter[0]
                    }
                })
                .then(response => {
                    setFilter(response.data);
                })
                .catch(error => {
                    console.error("Error fetching related experiences:", error);
                });
            }
            else{
                setNotFound(true);
            }
        }
    },[data]);

    const avatar=pageData?.acf.experience.avatar;
    const details=pageData?.acf.experience.details_box;

    console.log(filter);

    return(
        <>
            <GlobalMeta/>
            <InternalBanner
                featuredImage={pageData?. _embedded?.['wp:featuredmedia']?.[0]?.source_url}
                banner={pageData?.acf.internal_banner}
                isSingleExperience
            />
            <Container maxWidth='xl'>
                <Grid 
                    container
                    sx={{
                        marginTop:'2rem',
                        marginBottom:'2rem',
                    }}
                >
                    {isInitialLoading ?
                        <>
                            <Grid item xs={12} sm={12}>
                                <Skeleton variant="circular" width={100} height={100} />
                                <Skeleton variant="text" width="100%" height={40} />
                                <Skeleton variant="text" width="100%" height={40} />
                                <Skeleton variant="rectangular" width="100px" height={70} />
                            </Grid>
                            {/* <Grid item xs={12} sm={1} />
                            <Grid item xs={12} sm={4}>
                                <Skeleton variant="rectangular" width="100%" height={"100%"} />
                            </Grid> */}
                        </>
                    :
                        <>
                            <Grid item xs={12} sm={12}>
                                { avatar ?
                                    <img
                                        src={avatar}
                                        alt={pageData?.acf.experience.quote}
                                        style={{
                                            width:'100px',
                                            height:'auto',
                                            marginBottom:'1rem',
                                        }}
                                    />
                                : null }
                                <Typography 
                                    variant="p" 
                                    component="p" 
                                    sx={{
                                        fontWeight: 800,
                                        fontSize: '1.2rem',
                                        fontStyle: 'italic',
                                        marginBottom: '1rem',
                                    }}
                                >
                                    {pageData?.acf.experience.quote}
                                </Typography>
                                { partner ?
                                    <img
                                        src={partner?.acf.logo}
                                        alt={partner?.name}
                                        style={{
                                            width:'100px',
                                            height:'auto',
                                        }}
                                    />
                                : null }
                            </Grid>
                            {/* <Grid
                                item xs={12}
                                sm={1}
                            />
                            { details ?
                                <Grid 
                                    item xs={12}
                                    sm={4}
                                    sx={{
                                        backgroundColor:'#F0F0F0',
                                        padding:'1rem',
                                        marginTop: smDown ? '2rem' : 0,
                                    }}
                                >
                                    { details.map((detail, index)=>(
                                        <Box 
                                            key={index}
                                            sx={{
                                                display:'flex',
                                                justifyContent:'space-between',
                                                marginBottom:'10px',
                                            }}
                                        >
                                            <Typography 
                                                variant="p" 
                                                component="p" 
                                                sx={{
                                                    fontWeight: 800,
                                                    width: '31%',
                                                }}
                                            >
                                                {detail.title}
                                            </Typography>
                                            <Typography 
                                                variant="p" 
                                                component="p"
                                                sx={{
                                                    width: '65%',
                                                }}
                                            >
                                                {detail.content}
                                            </Typography>
                                        </Box>
                                    ))}
                                </Grid>
                            : null } */}
                        </>
                    }
                    </Grid>
                <HTMLComponents htmlComponents={pageData?.content?.rendered} isInitialLoading={isPending} pageID={pageData?.id} />
            </Container>

            <ImageBGSection content={pageData?.acf.image_background} loading={isPending} />

            {filter?.length > 0 &&
                <Container maxWidth='xl'>
                    <Typography 
                        variant="h3" 
                        component="h3"
                        sx={{
                            color: '#265DA5',
                            marginBottom: '2rem',
                            marginTop: '2rem',
                        }}    
                    >
                        More Experience
                    </Typography>
                    <Grid container spacing={4}>
                        {filter?.map((post, i)=>{
                            return(
                                <Grid item xs={12} md={6}>
                                    <ExperienceCard
                                        post={post}
                                        index={i}
                                    />
                                </Grid>
                            );
                        }
                        )}
                    </Grid>
                </Container>
            }
        </>
    );
}